import React, { useState, useEffect } from "react";

const Aifsd = () => {
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: ""
  });

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    setShowForm(false);
    setFormData({
      name: "",
      email: "",
      phone: ""
    });
    alert("Registration successful! We'll contact you soon.");
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = "1";
            entry.target.style.transform = "translateY(0)";
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px"
      }
    );

    const animateElements = document.querySelectorAll(
      ".takeaway-card, .instructor-content, .accordion-item"
    );
    animateElements.forEach((el) => {
      el.style.opacity = "0";
      el.style.transform = "translateY(20px)";
      el.style.transition = "opacity 0.6s ease, transform 0.6s ease";
      observer.observe(el);
    });

    return () => {
      animateElements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  return (
    <div className={`app ${showForm ? "form-visible" : ""}`}>
      {/* Sliding Form Panel */}
      <div className={`sliding-form-container ${showForm ? "visible" : ""}`}>
        <div className="sliding-form">
          <div className="form-header">
            <h3>Register for AI Full Stack Workshop</h3>
            <button className="close-button" onClick={() => setShowForm(false)}>
              &times;
            </button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Full Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="phone">Phone Number</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                required
              />
            </div>
            <button type="submit" className="submit-button">
              Submit Registration
            </button>
          </form>
        </div>
      </div>

      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1>
                Become a{" "}
                <span className="highlight">AI Full Stack Web Developer</span>{" "}
                Workshop in Tamil
              </h1>
              <p>
                Join the Full Stack Developer AI workshop at Uptor and gain
                hands-on expertise in frontend and backend development. Learn
                HTML, CSS, JavaScript, React.
              </p>

              <div className="registration-status">
                <button
                  className="register-button"
                  onClick={() => setShowForm(true)}
                >
                  Register Now for Just ₹99/-
                </button>
                <div className="student-info">
                  <div className="student-avatars">
                    <div className="avatar">A</div>
                    <div className="avatar">B</div>
                    <div className="avatar">C</div>
                    <div className="avatar">D</div>
                    <div className="avatar">+</div>
                  </div>
                  <div className="rating">⭐⭐⭐⭐⭐</div>
                  <span>10+ Happy Students 😊</span>
                </div>
              </div>
            </div>

            <div className="hero-image">
              <h2>AI Full Stack Development</h2>
              <p>For working professionals, career switchers & graduates</p>
              <div className="instructor-badge">Your Mentor: John Doe</div>
            </div>
          </div>
        </div>
      </section>
      {/* Key Takeaways */}
      <section className="takeaways">
        <div className="container">
          <h2>Key Takeaways From Our AI Full Stack Development Workshop</h2>
          <div className="takeaways-grid">
            {[
              {
                icon: "🎯",
                title: "Understand Full Stack Development",
                description:
                  "Learn what Full Stack Development is, why it's crucial, and how it's transforming the digital world — now with AI integration"
              },
              {
                icon: "🎯",
                title: "Career Clarity",
                description:
                  "Know the difference between roles like Frontend Developer, Backend Developer, Full Stack Engineer, and AI-Powered Web Developer."
              },
              {
                icon: "⚡",
                title: "Skills You Need",
                description:
                  "Get a clear roadmap of the coding languages, frameworks, and AI tools you need to launch your Full Stack career."
              },
              {
                icon: "💼",
                title: "Industry Insights",
                description:
                  "Learn what top companies are looking for when hiring Full Stack Developers — especially those with AI expertise."
              },
              {
                icon: "🚀",
                title: "No Coding? No Problem",
                description:
                  "Find out how you can start your Full Stack journey even if you have zero coding experience — we teach from basics!"
              },
              {
                icon: "🎨",
                title: "For Easy Transition",
                description:
                  "Discover how professionals from non-IT backgrounds can smoothly switch to Full Stack Development and AI roles."
              }
            ].map((item, index) => (
              <div className="takeaway-card" key={index}>
                <div className="takeaway-icon">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Instructor Section */}
      <section className="instructor">
        <div className="container">
          <div className="instructor-content">
            <div className="instructor-image">PS</div>
            <div className="instructor-info">
              <h2>John Doe</h2>
              <div className="title">Founder, LMES Academy & Uptor</div>
              <p>
                Mr. Prem, with over 10 years of experience in leading technology
                industries, is a seasoned expert in Full Stack Development and
                AI. His passion for building scalable, intelligent web
                applications has been the driving force behind the success of
                multiple ventures, including LMES Academy and Uptor.
              </p>
              <p>
                In this workshop, Premanand will share his deep expertise and
                practical insights on how Full Stack Development combined with
                AI can revolutionize the tech industry, streamline business
                processes, and open doors to exciting career opportunities.
                Learn directly from a visionary leader who has empowered
                countless professionals to launch and accelerate their tech
                careers.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Who Can Attend */}
      <section className="who-can-attend">
        <div className="container">
          <h2>Who Can Attend This Workshop</h2>
          <p>
            This workshop is designed for anyone curious about AI Full Stack
            Development.
          </p>
        </div>
        <div className="working-professionals">
          <div className="container">
            <div className="professionals-grid">
              <div className="professional-card">
                <h2 className="card-title">Working Professionals</h2>
                <p className="card-description">
                  From IT or Non-IT backgrounds and Looking to switch careers or
                  upskill for better job roles
                </p>
              </div>
              <div className="professional-card">
                <h2 className="card-title">Career Switchers</h2>
                <p className="card-description">
                  People from non-tech fields (like Mechanical, Civil, BPO,
                  Sales, etc.) who want to move into tech
                </p>
              </div>

              <div className="professional-card">
                <h2 className="card-title">Freelancers & Entrepreneurs</h2>
                <p className="card-description">
                  Want to build websites, apps, and tech products on their own
                  without depending on others.
                </p>
              </div>
            </div>

            <div className="freshers-section">
              <h2 className="card-title">Freshers & Recent Graduates</h2>
              <p className="card-description">
                Those who have completed degrees (B.E, B.Tech, B.Sc, MCA, etc.)
                and want to become job-ready with practical skills
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="callagainparent">
        <div className="callagain">
          <div className="secure">
            <h3>Secure Your Spot!</h3>
            <p>
              Elevate your career by joining our workshop and unlock new
              opportunities for success in the digital world.
            </p>
          </div>
          <div>
            <button
              className="register-button"
              onClick={() => setShowForm(true)}
            >
              Register Now for Just ₹99/-
            </button>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq">
        <div className="container">
          <h2>Frequently Asked Questions</h2>
          <div className="accordion">
            {[
              {
                question: "What is the duration of this workshop?",
                answer:
                  "The AI Full Stack Development workshop is a comprehensive 3-hour intensive session designed to provide you with essential knowledge and practical insights into the field."
              },
              {
                question: "Do I need prior coding experience?",
                answer:
                  "No prior coding experience is required! This workshop is designed for beginners and professionals from any background who want to learn about AI Full Stack Development."
              },
              {
                question: "Will this workshop be conducted in Tamil?",
                answer:
                  "Yes, this workshop will be conducted in Tamil to ensure better understanding and engagement for Tamil-speaking participants."
              },
              {
                question: "What materials will I receive?",
                answer:
                  "You will receive comprehensive study materials, resources, roadmaps, and access to exclusive content that will help you continue your learning journey."
              },
              {
                question: "Is this workshop suitable for career changers?",
                answer:
                  "Absolutely! This workshop is specifically designed for career switchers, working professionals, and graduates who want to transition into the AI Full Stack Development field."
              }
            ].map((item, index) => (
              <div
                className={`accordion-item ${
                  activeAccordion === index ? "active" : ""
                }`}
                key={index}
              >
                <div
                  className="accordion-header"
                  onClick={() => toggleAccordion(index)}
                >
                  <span>{item.question}</span>
                  <span className="accordion-icon">▼</span>
                </div>
                <div
                  className={`accordion-content ${
                    activeAccordion === index ? "active" : ""
                  }`}
                >
                  <p>{item.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Add some CSS for the modal and button */}
      <style jsx>{`
        .register-button {
          background-color: rgb(14,89,145);
          color: white;
          border: none;
          padding: 12px 24px;
          font-size: 16px;
          cursor: pointer;
          border-radius: 4px;
          font-weight: bold;
          transition: background-color 0.3s;
          margin-bottom: 30px;
        }

        .register-button:hover {
          background-color: #137eb1;
        }

        .sliding-form-container {
          position: fixed;
          top: 0;
          right: -100%;
          width: 100%;
          max-width: 400px;
          height: 100%;
          background-color: white;
          box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
          z-index: 1000;
          transition: right 0.4s ease-out;
          align-self: anchor-center;
          height: auto;
        }

        .sliding-form-container.visible {
          right: 550px;
                    border-radius: 10px;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        }

        .sliding-form {
          padding: 20px;
          height: 100%;
          overflow-y: auto;
          border-radius: 10px;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        }

        .form-header {
          position: relative;
          padding: 20px;
          border-bottom: 1px solid #dee2e6;
        }

        .form-header h3 {
          padding-right: 40px;
          margin: 0;
          font-size: 1.1rem;
          color: #333;
        }

        .close-button {
          position: absolute;
          top: 15px;
          right: 15px;
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          color: #6c757d;
          padding: 5px;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          transition: all 0.3s;
        }

        .close-button:hover {
          background-color: #f1f1f1;
          color: #333;
        }

        .form-group {
          margin-bottom: 20px;
        }

        .form-group label {
          display: block;
          margin-bottom: 8px;
          font-weight: 500;
          color: #495057;
        }

        .form-group input {
          width: 100%;
          padding: 10px;
          border: 1px solid #ced4da;
          border-radius: 4px;
          font-size: 16px;
          box-sizing: border-box;
        }

        .submit-button {
          width: 100%;
          padding: 12px;
          background-color: rgb(14,89,145);
          color: white;
          border: none;
          border-radius: 4px;
          font-size: 16px;
          cursor: pointer;
          transition: background-color 0.3s;
          font-weight: bold;
          margin-top: 10px;
        }

        .submit-button:hover {
          background-color: #137eb1;
        }

        /* Overlay when form is visible */
        .app::after {
          content: "";
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 999;
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.3s ease;
        }

        .app.form-visible::after {
          opacity: 1;
          pointer-events: auto;
        }
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: "Inter", sans-serif;
          line-height: 1.6;
          color: #333;
          background-color: #ffffff;
        }

        .working-professionals {
          font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
          max-width: 1200px;
          margin: 0 auto;
          padding: 40px 20px;
          color: #333;
        }

        .container {
          width: 100%;
        }

        .main-title {
          font-size: 2.5rem;
          color: #2c3e50;
          margin-bottom: 15px;
          text-align: center;
        }

        .subtitle {
          font-size: 1.2rem;
          line-height: 1.6;
          color: #555;
          text-align: center;
          margin-bottom: 40px;
        }

        .professionals-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 30px;
          margin-bottom: 40px;
        }

        .professional-card {
          background-color: #f9f9f9;
          border-radius: 8px;
          padding: 25px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease;
        }

        .professional-card:hover {
          transform: translateY(-5px);
        }

        .card-title {
          font-size: 1.5rem;
          color: #2c3e50;
          margin-bottom: 15px;
          border-bottom: 2px solid #3498db;
          padding-bottom: 10px;
        }

        .card-description {
          font-size: 1rem;
          line-height: 1.6;
          color: #555;
        }

        .divider {
          height: 1px;
          background-color: #ddd;
          margin: 50px 0;
        }

        .freshers-section {
          background-color: #f0f7ff;
          border-radius: 8px;
          padding: 30px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        /* Header */
        .header {
          background: #fff;
          padding: 20px 0;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          position: sticky;
          top: 0;
          z-index: 100;
        }

        .header-content {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .logo {
          font-size: 28px;
          font-weight: 700;
          color: #e91e63;
        }

        /* Hero Section */
        .hero {
          padding: 80px 0;
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        }

        .hero-content {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 60px;
          align-items: center;
        }

        .hero-text h1 {
          font-size: 3.5rem;
          font-weight: 700;
          margin-bottom: 20px;
          line-height: 1.2;
          text-align: left;
        }

        .hero-text .highlight {
          color: #e91e63;
          background: linear-gradient(45deg, #e91e63, #9c27b0);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .hero-text p {
          font-size: 1.2rem;
          margin-bottom: 30px;
          color: #666;
          text-align: left;
        }

        .registration-status {
          background: #fff;
          padding: 20px;
          border-radius: 12px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
          margin-bottom: 30px;
        }

        .status-badge {
          background: #ff6b6b;
          color: white;
          padding: 8px 16px;
          border-radius: 20px;
          font-size: 0.9rem;
          font-weight: 600;
          margin-bottom: 15px;
          display: inline-block;
        }

        .student-info {
          display: flex;
          align-items: center;
          gap: 15px;
        }

        .student-avatars {
          display: flex;
          margin-right: 10px;
        }

        .avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 2px solid #fff;
          margin-left: -10px;
          background: linear-gradient(45deg, #e91e63, #9c27b0);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 600;
        }

        .rating {
          color: #ffd700;
          font-size: 1.1rem;
        }

        .hero-image {
          background: linear-gradient(
            135deg,
            #137eb1 0%,
            #137eb1 50%,
            rgb(14,89,145) 100%
          );
          border-radius: 20px;
          padding: 40px;
          color: white;
          text-align: center;
          position: relative;
          overflow: hidden;
        }

        .hero-image::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(255,255,255,0.1)" stroke-width="1"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
          opacity: 0.3;
        }

        .hero-image h2 {
          font-size: 2.5rem;
          margin-bottom: 20px;
          position: relative;
          z-index: 1;
        }

        .hero-image p {
          font-size: 1.1rem;
          margin-bottom: 30px;
          position: relative;
          z-index: 1;
        }

        .instructor-badge {
          background: rgb(14,89,145);
          color: white;
          padding: 15px 25px;
          border-radius: 30px;
          font-weight: 600;
          position: relative;
          z-index: 1;
          display: inline-block;
        }

        /* Key Takeaways */
        .takeaways {
          padding: 100px 0;
          background: #fff;
        }

        .takeaways h2 {
          text-align: center;
          font-size: 2.5rem;
          margin-bottom: 60px;
          color: #333;
        }

        .takeaways-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
          gap: 30px;
        }

        .takeaway-card {
          background: #fff;
          padding: 30px;
          border-radius: 15px;
          box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          border-left: 4px solid #e91e63;
          animation: fadeInUp 0.6s ease forwards;
        }

        .takeaway-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
        }

        .takeaway-card:nth-child(1) {
          animation-delay: 0.1s;
        }
        .takeaway-card:nth-child(2) {
          animation-delay: 0.2s;
        }
        .takeaway-card:nth-child(3) {
          animation-delay: 0.3s;
        }
        .takeaway-card:nth-child(4) {
          animation-delay: 0.4s;
        }
        .takeaway-card:nth-child(5) {
          animation-delay: 0.5s;
        }
        .takeaway-card:nth-child(6) {
          animation-delay: 0.6s;
        }

        .takeaway-icon {
          width: 60px;
          height: 60px;
          background: linear-gradient(45deg, #e91e63, #9c27b0);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
          color: white;
          font-size: 1.5rem;
        }

        .takeaway-card h3 {
          font-size: 1.3rem;
          margin-bottom: 15px;
          color: #333;
          text-align: left;
        }

        .takeaway-card p {
          color: #666;
          line-height: 1.6;
          text-align: left;
        }

        /* Instructor Section */
        .instructor {
          padding: 100px 0;
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        }

        .instructor-content {
          display: grid;
          grid-template-columns: 400px 1fr;
          gap: 50px;
          align-items: center;
        }

        .instructor-image {
          width: 250px;
          height: 250px;
          border-radius: 50%;
          background: linear-gradient(45deg, #e91e63, #9c27b0);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 4rem;
          font-weight: 700;
          margin: 0 auto;
        }

        .instructor-info h2 {
          font-size: 2.5rem;
          margin-bottom: 10px;
          color: #333;
          text-align: left;
        }

        .instructor-info .title {
          font-size: 1.2rem;
          color: #e91e63;
          font-weight: 600;
          margin-bottom: 30px;
          text-align: left;
        }

        .instructor-info p {
          font-size: 1.1rem;
          line-height: 1.8;
          color: #666;
          margin-bottom: 20px;
          text-align: left;
        }

        /* Who Can Attend */
        .who-can-attend {
          padding-top: 30px;
          background: #fff;
          text-align: center;
        }

        .callagain {
          display: flex;
          justify-content: space-evenly;
          align-items: center;
          margin-bottom: 50px;
          background-color: #f9f9f9;
          border-radius: 8px;
          padding: 25px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          width: 80%;
        }

        .callagainparent {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .secure {
          text-align: left;
        }

        .who-can-attend h2 {
          font-size: 2.5rem;
          margin-bottom: 30px;
          color: #333;
        }

        .who-can-attend p {
          font-size: 1.2rem;
          color: #666;
          max-width: 600px;
          margin: 0 auto;
        }

        /* FAQ Accordion */
        .faq {
          padding: 100px 0;
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        }

        .faq h2 {
          text-align: center;
          font-size: 2.5rem;
          margin-bottom: 60px;
          color: #333;
        }

        .accordion {
          max-width: 800px;
          margin: 0 auto;
        }

        .accordion-item {
          background: #fff;
          border-radius: 10px;
          margin-bottom: 15px;
          overflow: hidden;
          box-shadow: 0 3px 15px rgba(0, 0, 0, 0.1);
        }

        .accordion-header {
          padding: 25px 30px;
          background: #fff;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-weight: 600;
          font-size: 1.1rem;
          color: #333;
          border-bottom: 1px solid #eee;
          transition: background-color 0.3s ease;
        }

        .accordion-header:hover {
          background: #f8f9fa;
        }

        .accordion-header.active {
          background: #e91e63;
          color: white;
        }

        .accordion-icon {
          font-size: 1.2rem;
          transition: transform 0.3s ease;
          margin-left: auto;
        }

        .accordion-header.active .accordion-icon {
          transform: rotate(180deg);
        }

        .accordion-content {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease;
        }

        .accordion-content.active {
          max-height: 200px;
        }

        .accordion-content p {
          padding: 25px 30px;
          color: #666;
          line-height: 1.6;
        }

        /* Footer */
        footer {
          background: #1a1a2e;
          color: white;
          padding: 50px 0;
          text-align: center;
        }

        .footer-content {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 40px;
          margin-bottom: 30px;
        }

        .footer-section h3 {
          margin-bottom: 20px;
          color: #e91e63;
        }

        .footer-section p {
          color: #ccc;
          line-height: 1.6;
        }

        .footer-bottom {
          border-top: 1px solid #333;
          padding-top: 30px;
          color: #999;
        }

        /* Animations */
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 1200px) {
          .hero-content {
            gap: 40px;
          }

          .hero-text h1 {
            font-size: 3rem;
          }
        }

        @media (max-width: 992px) {
          .working-professionals {
            font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
            max-width: 1200px;
            margin: 0 auto;
            padding: 0px;
            color: #333;
          }
          .hero-content {
            grid-template-columns: 1fr;
            gap: 40px;
          }

          .hero-text {
            order: 2;
          }

          .hero-image {
            order: 1;
            max-width: 500px;
            margin: 0 auto;
          }

          .instructor-content {
            grid-template-columns: 1fr;
            gap: 30px;
            text-align: center;
          }

          .instructor-image {
            margin-bottom: 30px;
          }

          .takeaways-grid {
            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          }
        }

        @media (max-width: 768px) {
          .callagain {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;
            margin-bottom: 50px;
            background-color: #f9f9f9;
            border-radius: 8px;
            padding: 25px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            width: 90%;
          }

          .callagainparent {
            display: flex;
            justify-content: center;
            align-items: center;
            padding-top: 30px;
          }
          .instructor {
            padding: 50px 0;
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          }
          .hero {
            padding: 20px 0;
          }

          .who-can-attend p {
            font-size: 1rem;
            color: #666;
            max-width: 600px;
            margin: 0 auto;
          }

          .hero-text h1 {
            font-size: 2.5rem;
          }

          .hero-text p {
            font-size: 1.1rem;
          }

          .student-info {
            flex-direction: column;
            align-items: flex-start;
            gap: 10px;
          }

          .takeaways h2,
          .faq h2,
          .who-can-attend h2 {
            font-size: 1.2rem;
            margin-bottom: 20px;
          }

          .accordion-header {
            padding: 20px;
            font-size: 1rem;
            text-align: left;
          }

          .accordion-content p {
            padding: 20px;
            text-align: left;
          }

          .sliding-form-container.visible {
            right: 0;
            max-width: 100%;
          }
        }

        @media (max-width: 576px) {
          .faq {
            padding: 30px 0;
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            margin-bottom: 30px;
          }
          .hero-text h1 {
            font-size: 2rem;
          }

          .hero-image h2 {
            font-size: 1.8rem;
          }

          .takeaway-card {
            padding: 20px;
          }

          .takeaway-icon {
            width: 50px;
            height: 50px;
            font-size: 1.2rem;
          }

          .takeaway-card h3 {
            font-size: 1.1rem;
          }

          .professional-card {
            padding: 20px;
          }

          .card-title {
            font-size: 1.3rem;
          }

          .register-button {
            padding: 10px 20px;
            font-size: 0.9rem;
          }

          .instructor-info h2 {
            font-size: 2rem;
          }

          .instructor-info p {
            font-size: 1rem;
          }
        }

        @media (max-width: 480px) {
          .hero-text h1 {
            font-size: 1.8rem;
          }

          .hero-text p {
            font-size: 1rem;
          }

          .takeaways-grid {
            grid-template-columns: 1fr;
          }

          .professionals-grid {
            grid-template-columns: 1fr;
          }

          .registration-status {
            padding: 15px;
          }

          .student-avatars .avatar {
            width: 30px;
            height: 30px;
            font-size: 0.8rem;
          }

          .instructor-image {
            width: 200px;
            height: 200px;
            font-size: 3rem;
          }
        }

        @media (max-width: 400px) {
          .hero-text h1 {
            font-size: 1.6rem;
          }

          .hero-image {
            padding: 30px 20px;
          }

          .hero-image h2 {
            font-size: 1.5rem;
          }

          .instructor-badge {
            padding: 10px 20px;
            font-size: 0.9rem;
          }

          .form-header h3 {
            font-size: 1rem;
          }

          .form-group input {
            padding: 8px;
            font-size: 14px;
          }

          .submit-button {
            padding: 10px;
            font-size: 14px;
          }
        }
      `}</style>
    </div>
  );
};

export default Aifsd;
